<template>
  <div class="pt-2" v-bind:style="{ background: setting.background_color }">
    <div v-if="!imageTakeView">
      <div v-if="recordVideo === false && recordAudio === false">
        <div class="row mx-0">
          <div class="col-12">
            <div class="feedback-header">
              <p class="ml-0">Please Answer This Question</p>
            </div>
          </div>
        </div>
        <div class="row mt-3 mx-0">
          <div class="col-12">
            <div class="feedback-option">
              <div class="panel">
                <div class="question-detail">
                  <div class="question-number d-flex align-items-center">
                    <div class="icon d-flex align-items-center">
                      <img src="../assets/question-icon.svg" alt="" />
                    </div>
                    <p class="mb-0 title">Question</p>
                  </div>
                  <h5 class="question-title">{{ question.title }}</h5>
                  <p class="question-subtitle">
                    {{ question.description }}
                  </p>
                  <div class="recording-time mb-3" v-if="successMessage === true">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#FF077B" />
                    </svg>
                    <p class="title ml-2 pl-1">Success!</p>
                  </div>
                  <div class="recording-time-warning mb-3" v-if="recordingDurationError === true && currentOption.recording_settings.allow_max_recording">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#FF3D00" />
                    </svg>
                    <p class="title ml-2 pl-1">
                      Error: Recording time must be under:
                      <span>{{ currentOption.recording_settings.max_minutes }}:{{ currentOption.recording_settings.max_seconds }}</span>
                    </p>
                  </div>
                  <div class="question-options">
                    <p class="option-head" v-if="selectText === false && uploadedVideo === '' && uploadedAudio === '' && uploadedImage === ''">
                      Select an option to respond:
                    </p>
                    <div class="options d-flex align-items-center justify-content-center">
                      <div class="option-item d-sm-flex align-items-center justify-content-center" @click="recordNewVideo" v-if="selectVideo === true && uploadedVideo === '' && recordVideo === false && this.isWebDevice">
                        <svg widvideoth="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.8333 7V4.66667C11.8333 4.3 11.5333 4 11.1667 4H3.16667C2.8 4 2.5 4.3 2.5 4.66667V11.3333C2.5 11.7 2.8 12 3.16667 12H11.1667C11.5333 12 11.8333 11.7 11.8333 11.3333V9L14.5 11.6667V4.33333L11.8333 7Z" fill="#ffffff" />
                        </svg>
                        <p class="mb-0">Record Video</p>
                      </div>
                      <div class="option-item" v-if="selectVideo === true && videoUpload === false && uploadedVideo === '' && recordVideo === false && currentOption.recording_settings.allow_uploads && this.isWebDevice">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.50016 10.6667H10.5002V6.66667H13.1668L8.50016 2L3.8335 6.66667H6.50016V10.6667ZM3.8335 12H13.1668V13.3333H3.8335V12Z" fill="white" />
                        </svg>
                        <label for="upload-video" class="mb-0 upload-style" v-if="this.isWebDevice">Upload Video</label>
                        <input id="upload-video" type="file" accept="video/*" @change="selectVideoUpload" />
                      </div>
                      <div class="option-item" v-if="selectVideo === true && videoUpload === false && uploadedVideo === '' && recordVideo === false && !this.isWebDevice">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.50016 10.6667H10.5002V6.66667H13.1668L8.50016 2L3.8335 6.66667H6.50016V10.6667ZM3.8335 12H13.1668V13.3333H3.8335V12Z" fill="white" />
                        </svg>
                        <label for="upload-video" class="mb-0 upload-style" v-if="!this.isWebDevice && currentOption.recording_settings.allow_uploads">Record/Upload Video</label>
                        <input id="upload-video" type="file" v-if="!this.isWebDevice && currentOption.recording_settings.allow_uploads" accept="video/*" @change="selectVideoUpload" />
                        <label for="record-video" class="mb-0 upload-style" v-if="!this.isWebDevice && !currentOption.recording_settings.allow_uploads">Record Video</label>
                        <input id="record-video" capture type="file" v-if="!this.isWebDevice && !currentOption.recording_settings.allow_uploads" accept="video/*" @change="selectVideoUpload" />
                      </div>
                      <div class="option-item d-sm-flex" v-if="selectAudio === true && uploadedAudio === ''" @click="recordNewAudio">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M8.50016 9.33301C9.60683 9.33301 10.4935 8.43967 10.4935 7.33301L10.5002 3.33301C10.5002 2.22634 9.60683 1.33301 8.50016 1.33301C7.3935 1.33301 6.50016 2.22634 6.50016 3.33301V7.33301C6.50016 8.43967 7.3935 9.33301 8.50016 9.33301ZM12.0335 7.33301C12.0335 9.33301 10.3402 10.733 8.50016 10.733C6.66016 10.733 4.96683 9.33301 4.96683 7.33301H3.8335C3.8335 9.60634 5.64683 11.4863 7.8335 11.813V13.9997H9.16683V11.813C11.3535 11.493 13.1668 9.61301 13.1668 7.33301H12.0335Z"
                            fill="#ffffff"
                          />
                        </svg>
                        <p class="mb-0">Record Audio</p>
                      </div>
                      <div class="option-item" v-if="selectAudio === true && uploadedAudio === '' && currentOption.recording_settings.allow_uploads">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.50016 10.6667H10.5002V6.66667H13.1668L8.50016 2L3.8335 6.66667H6.50016V10.6667ZM3.8335 12H13.1668V13.3333H3.8335V12Z" fill="white" />
                        </svg>
                        <label for="upload-audio" class="mb-0 upload-style">Upload Audio</label>
                        <input type="file" id="upload-audio" accept="audio/*" ref="myFiles" @change="selectAudioUpload" />
                      </div>
                      <div class="option-item image-option" id="capture" v-if="selectImage === true && takeImage === '' && isWebDevice" @click="takeWebCamViewClick">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.50003 10.1334C9.67824 10.1334 10.6334 9.17824 10.6334 8.00003C10.6334 6.82182 9.67824 5.8667 8.50003 5.8667C7.32182 5.8667 6.3667 6.82182 6.3667 8.00003C6.3667 9.17824 7.32182 10.1334 8.50003 10.1334Z" fill="white" />
                          <path
                            d="M6.50016 1.3335L5.28016 2.66683H3.16683C2.4335 2.66683 1.8335 3.26683 1.8335 4.00016V12.0002C1.8335 12.7335 2.4335 13.3335 3.16683 13.3335H13.8335C14.5668 13.3335 15.1668 12.7335 15.1668 12.0002V4.00016C15.1668 3.26683 14.5668 2.66683 13.8335 2.66683H11.7202L10.5002 1.3335H6.50016ZM8.50016 11.3335C6.66016 11.3335 5.16683 9.84016 5.16683 8.00016C5.16683 6.16016 6.66016 4.66683 8.50016 4.66683C10.3402 4.66683 11.8335 6.16016 11.8335 8.00016C11.8335 9.84016 10.3402 11.3335 8.50016 11.3335Z"
                            fill="white"
                          />
                        </svg>
                        <label class="mb-0 upload-style">Take Photo w/ Webcam</label>
                        <!-- <input type="file" accept="image/*" class="form-control" ref="uploadImg" @change="selectImageUpload" /> -->
                      </div>
                      <div class="option-item image-option" id="capture" v-if="selectImage === true && !uploadedImageFile && !isWebDevice">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0)">
                            <path
                              d="M15.4997 10H14.1663V11.3333H15.4997V10ZM15.4997 7.33333H14.1663V8.66667H15.4997V7.33333ZM15.4997 12.6667H14.1663V14C14.833 14 15.4997 13.3333 15.4997 12.6667ZM10.1663 2H8.83301V3.33333H10.1663V2ZM15.4997 4.66667H14.1663V6H15.4997V4.66667ZM14.1663 2V3.33333H15.4997C15.4997 2.66667 14.833 2 14.1663 2ZM2.16634 14H7.49967V10H0.833008V12.6667C0.833008 13.4 1.43301 14 2.16634 14ZM2.16634 4.66667H0.833008V6H2.16634V4.66667ZM10.1663 12.6667H8.83301V14H10.1663V12.6667ZM12.833 2H11.4997V3.33333H12.833V2ZM12.833 12.6667H11.4997V14H12.833V12.6667ZM2.16634 2C1.49967 2 0.833008 2.66667 0.833008 3.33333H2.16634V2ZM2.16634 7.33333H0.833008V8.66667H2.16634V7.33333ZM7.49967 2H6.16634V3.33333H7.49967V2ZM4.83301 2H3.49967V3.33333H4.83301V2Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="16" height="16" fill="white" transform="translate(0.166504)" />
                            </clipPath>
                          </defs>
                        </svg>
                        <label class="mb-0 upload-style">Take/Upload Photo</label>
                        <input type="file" accept="image/*" class="form-control" ref="uploadImg" @change="selectImageUpload" />
                      </div>
                      <div class="option-item image-option" id="capture" v-if="selectImage === true && takeImage === '' && isWebDevice" @click="takeScreenShotClick">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0)">
                            <path
                              d="M15.4997 10H14.1663V11.3333H15.4997V10ZM15.4997 7.33333H14.1663V8.66667H15.4997V7.33333ZM15.4997 12.6667H14.1663V14C14.833 14 15.4997 13.3333 15.4997 12.6667ZM10.1663 2H8.83301V3.33333H10.1663V2ZM15.4997 4.66667H14.1663V6H15.4997V4.66667ZM14.1663 2V3.33333H15.4997C15.4997 2.66667 14.833 2 14.1663 2ZM2.16634 14H7.49967V10H0.833008V12.6667C0.833008 13.4 1.43301 14 2.16634 14ZM2.16634 4.66667H0.833008V6H2.16634V4.66667ZM10.1663 12.6667H8.83301V14H10.1663V12.6667ZM12.833 2H11.4997V3.33333H12.833V2ZM12.833 12.6667H11.4997V14H12.833V12.6667ZM2.16634 2C1.49967 2 0.833008 2.66667 0.833008 3.33333H2.16634V2ZM2.16634 7.33333H0.833008V8.66667H2.16634V7.33333ZM7.49967 2H6.16634V3.33333H7.49967V2ZM4.83301 2H3.49967V3.33333H4.83301V2Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="16" height="16" fill="white" transform="translate(0.166504)" />
                            </clipPath>
                          </defs>
                        </svg>
                        <label class="mb-0 upload-style">Take a Screenshot</label>
                        <!-- <input type="file" accept="image/*" class="form-control" ref="uploadImg" @change="selectImageUpload" /> -->
                      </div>
                      <div class="option-item image-option" v-if="selectImage === true && uploadedImage === '' && isWebDevice">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.50016 10.6667H10.5002V6.66667H13.1668L8.50016 2L3.8335 6.66667H6.50016V10.6667ZM3.8335 12H13.1668V13.3333H3.8335V12Z" fill="white" />
                        </svg>
                        <label for="upload-audio" class="mb-0 upload-style">Upload an Image</label>
                        <input type="file" accept="image/*" class="form-control" ref="uploadImg" @change="selectImageUpload" />
                      </div>
                      <div class="w-100" v-if="selectText === true">
                        <textarea v-model="textAnswer" class="form-control" name="ans" placeholder="Type your answer here..."></textarea>
                        <!-- <input type="text" v-model="textAnswer" class="form-control" name="ans"> -->
                      </div>
                    </div>
                  </div>
                  <!--                  <div class="w-100" v-if="selectText === true">-->
                  <!--                    <textarea v-model="textAnswer" class="form-control" name="ans" placeholder="Type your answer here..."></textarea>-->
                  <!--                    &lt;!&ndash; <input type="text" v-model="textAnswer" class="form-control" name="ans"> &ndash;&gt;-->
                  <!--                  </div>-->
                </div>
                <div
                  class="recording-time"
                  v-if="(selectVideo === true && uploadedVideo === '' && recordVideo === false && currentOption.recording_settings.allow_max_recording) || (selectAudio === true && currentOption.recording_settings.allow_max_recording === 1 && currentOption.recording_settings.allow_max_recording)"
                >
                  <img src="../assets/meter.svg" alt="" />
                  <p class="title">Max Recording Time:</p>
                  <p class="time">{{ String(currentOption.recording_settings.max_minutes).padStart(2, "0") }}:{{ String(currentOption.recording_settings.max_seconds).padStart(2, "0") }}</p>
                </div>

                <div class="row" v-if="uploadedVideo !== ''">
                  <div class="col-12">
                    <VideoJs :src="uploadedVideo" :videoFile="uploadedVideofile" id="uploaded-video-player" @selected-video-duration="updateParentDuration" type="video/mp4" />
                  </div>
                </div>
                <div class="row" v-if="uploadedAudio !== ''">
                  <div class="col-12">
                    <CustomAudioRecorder :audio-src="uploadedAudio" :audio-file="uploadedAudioFile"></CustomAudioRecorder>
                    <!--                  <audio controls>-->
                    <!--                    <source :src="uploadedAudio" type="audio/mpeg">-->
                    <!--                    Your browser does not support the audio element.-->
                    <!--                    <CustomAudioRecorder></CustomAudioRecorder>-->
                    <!--                  </audio>-->
                  </div>
                </div>
                <div class="row" v-if="uploadedImage !== ''">
                  <div class="col-12">
                    <div class="uploaded-image">
                      <img :src="uploadedImage" class="img-fluid" />
                    </div>
                  </div>
                </div>
                <div class="row" v-if="textAnswer !== '' && localAnswer === true">
                  <div class="col-12">
                    <p>{{ textAnswer }}</p>
                  </div>
                </div>
                <div class="row mt-3" v-if="uploadedVideo !== '' || uploadedAudio !== '' || uploadedImage !== '' || selectText === true">
                  <div class="col-12 d-flex">
                    <!--                <button class="btn btn-solid mr-2" @click="saveAnswer"><img src="../assets/arrow-right.svg" class="icon" alt=""> Save</button>-->
                    <!-- <button class="btn btn-hollow mr-2" @click="saveAnswer">Save</button> -->
                    <button class="btn btn-hollow" v-if="uploadedVideo !== ''" @click="removeUploadedVideo">
                      <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.49992 12.6667C4.49992 13.4 5.09992 14 5.83325 14H11.1666C11.8999 14 12.4999 13.4 12.4999 12.6667V4.66667H4.49992V12.6667ZM13.1666 2.66667H10.8333L10.1666 2H6.83325L6.16659 2.66667H3.83325V4H13.1666V2.66667Z" />
                      </svg>
                      Remove Video
                    </button>
                    <button class="btn btn-hollow" v-if="uploadedAudio !== ''" @click="removeUploadedAudio">
                      <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.49992 12.6667C4.49992 13.4 5.09992 14 5.83325 14H11.1666C11.8999 14 12.4999 13.4 12.4999 12.6667V4.66667H4.49992V12.6667ZM13.1666 2.66667H10.8333L10.1666 2H6.83325L6.16659 2.66667H3.83325V4H13.1666V2.66667Z" />
                      </svg>
                      Remove Audio
                    </button>
                    <button class="btn btn-hollow" v-if="uploadedImage !== ''" @click="removeUploadedImage">
                      <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.49992 12.6667C4.49992 13.4 5.09992 14 5.83325 14H11.1666C11.8999 14 12.4999 13.4 12.4999 12.6667V4.66667H4.49992V12.6667ZM13.1666 2.66667H10.8333L10.1666 2H6.83325L6.16659 2.66667H3.83325V4H13.1666V2.66667Z" />
                      </svg>
                      Remove Image
                    </button>
                    <button class="btn btn-hollow" v-if="textAnswer !== ''" @click="removeTextAnswer">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3 mx-0" v-if="selectText === false && uploadedVideo === '' && uploadedAudio === '' && uploadedImage === '' && localAnswer === false">
          <div class="col-12">
            <HelpfullTipsVideo v-if="selectVideo === true"></HelpfullTipsVideo>
            <HelpfullTipsAudio v-if="selectAudio === true"></HelpfullTipsAudio>
          </div>
        </div>
        <div class="row mt-3 mx-0" v-if="uploadedVideo !== '' || uploadedAudio !== '' || uploadedImage !== '' || selectText === true">
          <div class="col-12">
            <button class="btn btn-solid w-100" v-bind:disabled="(recordingDurationError && currentOption.recording_settings.allow_max_recording) || loading" @click="saveAnswer">
              <i class="fa fa-spinner fa-spin" v-if="loading"></i>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="" xmlns="http://www.w3.org/2000/svg" class="icon">
                <path d="M8.58984 16.34L13.1698 11.75L8.58984 7.16L9.99984 5.75L15.9998 11.75L9.99984 17.75L8.58984 16.34Z" />
              </svg>
              Continue
            </button>
          </div>
        </div>
        <div class="row mt-3 mx-0">
          <div class="col-12">
            <a class="back-btn btn-link d-flex align-items-center" @click="goBack">
              <div class="icon">
                <img src="../assets/angle-left.svg" alt="" />
              </div>
              <div class="text">
                <p class="mb-0">Back</p>
              </div>
            </a>
            <div class="d-flex align-items-center justify-content-center">
              <Branding></Branding>
            </div>
          </div>
        </div>
      </div>
      <div v-if="recordVideo === true || recordAudio === true" cl style="height: 100vh; max-height: -webkit-fill-available">
        <recorder @clicked="saveAnswerVideo" @close="removeUploadedVideo" v-if="recordVideo === true && 0"></recorder>
        <recordVideoPartial :record-video="recordVideo" @clicked="saveAnswerVideo" v-if="recordVideo === true" @event="backRecordNewVideo" @close="removeUploadedVideo"></recordVideoPartial>
        <AudioRecorder @clicked="saveAnswerAudio" @close="removeUploadedAudio" v-if="recordAudio === true"></AudioRecorder>
      </div>
    </div>
    <div v-if="imageTakeView">
      <div v-if="takeImageWebCamView">
        <TakeImageWebCam @savedTakeWebCamImage="savedTakeWebCamImage" @backFromTakeWebCam="backFromTakeWebCam"></TakeImageWebCam>
      </div>
      <div v-if="takeScreenShot">
        <TakeScreenShot @savedTakeScreenShotImage="savedTakeScreenShotImage" @backFromTakeWebCam="backFromTakeWebCam" @retakeScreenShot="retakeScreenShot"></TakeScreenShot>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VideoJs from "./Video";
import CustomAudioRecorder from "./CustomAudioRecorder";
import recorder from "./recorder";
import AudioRecorder from "./AudioRecorder";
import { uuid } from "vue-uuid";
import HelpfullTipsVideo from "./partials/HelpfullTipsVideo.vue";
import HelpfullTipsAudio from "./partials/HelpfullTipsAudio.vue";
import recordVideoPartial from "./RecordVideoPartial";
import TakeImageWebCam from "./partials/TakeImageWebCam";
import TakeScreenShot from "./partials/TakeScreenShot";
import Branding from "./partials/branding.vue";

export default {
  name: "Question",
  components: {
    recordVideoPartial,
    recorder,
    VideoJs,
    AudioRecorder,
    CustomAudioRecorder,
    HelpfullTipsVideo,
    HelpfullTipsAudio,
    TakeImageWebCam,
    TakeScreenShot,
    Branding,
  },
  data() {
    return {
      uuid: uuid.v1(),
      question: {},
      anserType: "",
      submitAnswer: false,
      response: "",
      currentOption: "",
      selectVideo: false,
      videoUpload: false,
      recordVideo: false,
      selectVideoUploadOption: false,
      uploadedVideo: "",
      recordingDurationError: false,
      successMessage: false,
      uploadedVideofile: "",
      selectAudio: false,
      uploadedAudioFile: "",
      uploadedAudio: "",
      uploadAudio: "",
      selectAudioUploadOption: false,
      recordAudio: false,
      selectText: false,
      selectImage: false,
      uploadedImage: "",
      takeImage: "",
      takeScreenShot: false,
      uploadedImageFile: "",
      textAnswer: "",
      localCurrentQuestion: {},
      localQuestionList: {},
      localAnswer: false,
      isWebDevice: this.$isWebDevice,
      selectedQuestionResponse: "",
      submitedQuestion: null,
      user: {
        pixel_key: "",
        ip: "",
        location: "",
        agent: navigator.userAgent,
        current_page: encodeURIComponent(window.location.href),
      },
      img: "https://images.pexels.com/photos/4323307/pexels-photo-4323307.jpeg",
      takeImageWebCamView: false,
      imageTakeView: false,
      loading: false,
    };
  },
  created() {
    this.checkLocalStorage();
    this.response = this.$session.get("response");
    this.setting = this.$session.get("response").settings;
    this.user.ip = this.get_ip();
    this.user.location = this.get_location_data(this.get_ip());
    if (this.$canary_load_url) {
      this.user.current_page = encodeURIComponent(this.$canary_load_url);
    } else {
      this.user.current_page = encodeURIComponent(window.location.href);
    }
    this.user.pixel_key = this.$session.get("pixelKey");
  },
  methods: {
    change({ coordinates, canvas }) {
      console.log(coordinates, canvas);
    },
    collapseClick() {
      setTimeout(() => {
        this.$helpers.resizeIframeEvent();
      }, 800);
    },
    updateParentDuration(value_from_child) {
      if (this.currentOption.recording_settings && this.currentOption.recording_settings.allow_max_recording) {
        let limit_recording = this.currentOption.recording_settings.max_minutes * 60 + this.currentOption.recording_settings.max_seconds;
        if (limit_recording < value_from_child) {
          this.recordingDurationError = true;
          this.successMessage = false;
        } else {
          this.recordingDurationError = false;
          this.successMessage = true;
        }
      } else {
        this.successMessage = true;
      }
    },
    get_ip() {
      /* Return the ip from session store if any */
      if (sessionStorage.getItem("user_ip") && sessionStorage.getItem("user_ip") != "") {
        return sessionStorage.getItem("user_ip");
      } else {
        let xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", "https://api.ipify.org", false);
        xmlHttp.send(null);
        let ip = xmlHttp.responseText;
        /* Set it to the session storage to avoid multiple requests to this website */
        sessionStorage.setItem("user_ip", ip);
        return ip;
      }
    },
    get_location_data(ip) {
      let xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", `https://www.iplocate.io/api/lookup/${ip}`, false);
      xmlHttp.send(null);
      /* Try and get details from the response */
      try {
        let response = JSON.parse(xmlHttp.responseText);
        let user_location = JSON.stringify({
          city: response.city,
          country: response.country,
          country_code: response.country_code,
        });
        /* Set it to the session storage to avoid multiple requests to this website */
        sessionStorage.setItem("user_location", user_location);
        return user_location;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    send_tracking_data(params) {
      // console.log(params, this.$session.get('baseUrl'))
      let query = "?";
      query += Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let send = new Image();
      // console.log(send);
      send.src = `${this.$session.get("baseUrl")}/pixel-track/${query}`;
    },
    goBack() {
      if (this.uploadedAudio !== "") {
        this.removeUploadedAudio();
      } else if (this.recordAudio === true) {
        this.backRecordNewAudio;
      } else {
        return this.$router.go(-1);
      }
      // this.nextQuestion(-1)
    },
    backFromTakeWebCam() {
      this.takeImageWebCamView = false;
      this.imageTakeView = false;
      this.selectImage = true;
      this.takeImage = "";
    },
    checkLocalStorage() {
      // console.log('response', this.response)
      this.currentOption = this.$session.get("currentOption");
      this.question = this.$session.get("currtenQuestion");
      this.selectVideo = this.$session.get("selectVideo");
      this.selectAudio = this.$session.get("selectAudio");
      this.selectText = this.$session.get("selectText");
      this.selectImage = this.$session.get("selectImage");

      // this.localQuestionList =  JSON.parse(localStorage.getItem('questionList'))
      // this.localCurrentQuestion =  JSON.parse(localStorage.getItem('localquestion'))
      //
      // if(this.localCurrentQuestion.answer_type !== '' && Object.keys(this.localCurrentQuestion.answer).length !== 0) {
      //   console.log('this.localAnswer = true', this.localCurrentQuestion.answer_type, Object.keys(this.localCurrentQuestion.answer).length !== 0)
      //   this.localAnswer = true
      //   var local_answer_type = this.localCurrentQuestion.answer_type
      //   this[local_answer_type]  = true
      //   if(local_answer_type == 'selectVideo'){
      //     this.uploadedVideo = this.localCurrentQuestion.answer_url
      //     this.uploadedVideofile = this.localCurrentQuestion.answer
      //   } else if(local_answer_type == 'selectAudio'){
      //     this.uploadedAudio = this.localCurrentQuestion.answer_url
      //     this.uploadedAudioFile = this.localCurrentQuestion.answer
      //   } else if(local_answer_type == 'selectImage'){
      //     this.uploadedImage = this.localCurrentQuestion.answer_url
      //     this.uploadedImageFile = this.localCurrentQuestion.answer
      //   } else if(local_answer_type == 'selectText'){
      //     this.textAnswer = this.localCurrentQuestion.answer
      //   }
      // }
    },
    selectVideoUpload(e) {
      this.videoUpload = true;
      const file = e.target.files[0];
      this.uploadedVideofile = file;
      this.uploadedVideo = URL.createObjectURL(file);

      // this.setLocalStorage(this.uploadedVideofile, this.uploadedVideo, 'selectVideo', this.question.option_question_id)
    },
    backRecordNewVideo() {
      this.recordVideo = false;
      this.selectedQuestionResponse = "video";
    },
    recordNewVideo() {
      this.recordVideo = true;
      this.selectedQuestionResponse = "video";
      // this.$router.push({ name: "RecordVideoPermission" });
      // navigator.permissions.query({ name: "camera" }).then((result) => {
      //   console.log(result);
      //   if (result.state === "granted") {
      //     this.recordVideo = true;
      //     this.selectedQuestionResponse = "video";
      //   } else {

      //   }
      //   // Don't do anything if the permission was denied.
      // });
      // this.$router.push({ name: "RecordVideoPermission" });
    },
    saveAnswerVideo(value) {
      this.uploadedVideofile = value;
      this.uploadedVideo = URL.createObjectURL(value);
      // this.setLocalStorage(this.uploadedVideofile, this.uploadedVideo, 'selectVideo', this.question.option_question_id)
      this.recordVideo = false;
      this.videoUpload = false;
    },
    saveAnswerAudio(value) {
      this.recordAudio = false;
      this.uploadedAudioFile = value[0];
      this.uploadedAudio = value[1];
      if (this.uploadedAudioFile && this.uploadedAudioFile.duration) {
        let limit_recording = this.currentOption.recording_settings.max_minutes * 60 + this.currentOption.recording_settings.max_seconds;
        if (limit_recording < this.uploadedAudioFile.duration) {
          this.recordingDurationError = true;
        } else {
          this.recordingDurationError = false;
        }
        // console.log(this.recordingDurationError);
      }
    },
    removeUploadedVideo() {
      this.recordVideo = false;
      this.uploadedVideofile = "";
      this.uploadedVideo = "";
      this.videoUpload = false;
      this.localAnswer = false;
      this.recordingDurationError = false;
    },

    // setLocalStorage(value, value_url = '', value_type, qid){
    //   this.localAnswer = true
    //   this.localQuestionList.questions.filter(function (query){
    //     if(query.option_question_id == qid){
    //       query.answer_type = value_type
    //       query.answer = value
    //       query.answer_url = value_url
    //     }
    //   })
    //   localStorage.setItem('questionList', JSON.stringify(this.localQuestionList));
    //
    // },

    selectAudioUpload(e) {
      this.uploadAudio = true;
      const file = e.target.files[0];
      this.uploadedAudioFile = file;
      this.uploadedAudio = URL.createObjectURL(file);
      // this.setLocalStorage(this.uploadedAudioFile, this.uploadedAudio, 'selectAudio', this.question.option_question_id)
    },
    recordNewAudio() {
      this.recordAudio = true;
      // this.$router.push({ name: 'recordAudio'})
    },
    backRecordNewAudio() {
      this.recordAudio = false;
    },
    removeUploadedAudio() {
      this.recordAudio = false;
      this.localAnswer = false;
      this.uploadedAudio = "";
    },
    selectImageUpload(e) {
      var file = e.target.files[0];
      this.uploadedImageFile = file;
      this.uploadedImage = URL.createObjectURL(this.uploadedImageFile);
      // this.setLocalStorage(this.uploadedImageFile, this.uploadedImage, 'selectImage', this.question.option_question_id)
    },
    removeUploadedImage() {
      this.uploadedImage = "";
      this.localAnswer = false;
      this.takeImage = "";
      this.uploadedImageFile = false;
    },
    removeTextAnswer() {
      this.textAnswer = "";
      this.selectText = true;
      this.localAnswer = false;
    },
    saveAnswer() {
      if (this.recordingDurationError && this.currentOption.recording_settings.allow_max_recording) {
        return;
      }
      this.submitedQuestion = this.question;
      this.loading = true;
      if (this.recordVideo || this.uploadedVideo) {
        this.anserType = "video";
        this.uploadVideoChunks(this.uploadedVideofile);
      } else if (this.recordAudio || this.uploadedAudioFile) {
        this.anserType = "audio";
        if (this.recordAudio !== "") {
          this.uploadVideoChunks(this.uploadedAudioFile, "audio");
        } else {
          // console.log("upload audio", this.uploadedAudio);
          // this.uploadVideoChunks(this.uploadedAudio)
        }
      } else if (this.uploadedImage) {
        this.anserType = "image";
        this.uploadVideoChunks(this.uploadedImageFile);
        // this.uploadedImageFile
        // this.uploadedImage = ''
      } else if (this.selectText) {
        this.anserType = "text";
        // this.setLocalStorage(this.textAnswer, '', 'selectText', this.question.option_question_id)
        this.trackingTextQuestionData(this.textAnswer);
      }
      this.submitAnswer = true;
      this.nextQuestion(1);
      this.loading = false;
      // this.$alert('Successfully Submit', 'Success', 'success')
    },
    resetSelectedQuestion() {
      this.selectVideo = this.$session.get("selectVideo");
      this.selectAudio = this.$session.get("selectAudio");
      this.selectText = this.$session.get("selectText");
      this.selectImage = this.$session.get("selectImage");
      this.uploadedVideo = "";
      this.recordVideo = false;
      this.recordAudio = false;
      this.uploadedAudio = "";
      this.uploadedImage = "";
    },
    nextQuestion(operator) {
      if (this.submitAnswer === false) {
        this.$alert("Please Save Answer Before Submit", "Warning", "warning");
        return;
      }
      var indexIs = this.currentOption.questions.findIndex((questions) => questions.option_question_id === this.question.option_question_id);
      indexIs = indexIs + operator;
      var questionLength = this.currentOption.questions.length;
      this.submitAnswer = false;
      if (indexIs < questionLength) {
        var newQuestion = this.currentOption.questions[indexIs];
        this.question = newQuestion;
        var questionIs = this.question.option_question_id;
        var optionIS = this.currentOption.option_unique_id;
        this.$router.push({
          name: "QuestionView",
          params: { id: optionIS, qid: questionIs },
        });
      } else if (indexIs >= questionLength) {
        this.$router.push({ name: "OptionSubmit" });
      } else {
        this.$router.push({ name: "Home" });
      }
    },
    uploadVideoChunks(file, file_type) {
      var loaded = 0;
      var max_chunk_size = 2000000;
      max_chunk_size = parseInt(max_chunk_size);
      console.log(max_chunk_size);
      var total_file_size = file.size;
      var reader = new FileReader();
      var unique_file_name = this.uuid;
      if (file.name) {
        unique_file_name += "_" + file.name;
      }
      var blob = file.slice(loaded, max_chunk_size);
      reader.readAsArrayBuffer(blob);
      var unique_id = this.response.unique_id;
      var totalFailures = 0;
      var this_pointer = this;
      let base_url = this.$session.get("baseUrl");
      reader.onload = function() {
        var fd = new FormData();
        fd.append("filedata", new File([reader.result], unique_file_name));
        fd.append("loaded", loaded);
        fd.append("total_file_size", total_file_size);
        fd.append("notification_unique_id", unique_id);
        fd.append("selected_option_id", this_pointer.currentOption.option_unique_id);
        if (file_type) {
          fd.append("file_type", file_type);
        }

        axios
          .post(`${base_url}api/video-upload/upload_video_chunks`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then(
            (response) => {
              loaded += max_chunk_size;
              if (loaded < total_file_size) {
                blob = file.slice(loaded, loaded + max_chunk_size);
                reader.readAsArrayBuffer(blob);
              } else {
                loaded = total_file_size;
                this_pointer.trackingData(response);
              }
            },
            (error) => {
              if (totalFailures++ < 3) {
                // atleast try 3 times to upload file even on failure
                reader.readAsBinaryString(blob);
              }
              console.log(error);
            }
          );
      };
    },
    trackingData(response) {
      var total_question = this.currentOption.questions.length;
      this.send_tracking_data({
        ...this.user,
        notification_id: this.response.notification_id,
        question_id: this.submitedQuestion.option_question_id,
        answer: response.data.response.uploaded_path,
        type: "canary_feedback_question_submit",
        subtype: "question_submit", //
        unique_uuid: this.$session.get("uuid"), // Unique
        total_questions: total_question,
        question_type: this.anserType,
      });
    },
    trackingTextQuestionData(response) {
      var total_question = this.currentOption.questions.length;
      this.send_tracking_data({
        ...this.user,
        notification_id: this.response.notification_id,
        question_id: this.question.option_question_id,
        answer: response,
        type: "canary_feedback_question_submit",
        subtype: "question_submit", //
        unique_uuid: this.$session.get("uuid"), // Unique
        total_questions: total_question,
        question_type: this.anserType,
      });
    },
    takeWebCamViewClick() {
      this.takeImageWebCamView = true;
      this.imageTakeView = true;
    },
    takeScreenShotClick() {
      this.takeScreenShot = true;
      this.imageTakeView = true;
    },
    retakeScreenShot() {
      this.takeScreenShot = true;
      this.imageTakeView = true;
    },
    savedTakeWebCamImage(imageUrl) {
      // var file = e.target.files[0];
      this.uploadedImageFile = imageUrl;
      this.uploadedImage = URL.createObjectURL(imageUrl);
      this.takeImageWebCamView = false;
      this.takeImage = true;
      this.imageTakeView = false;
    },
    savedTakeScreenShotImage(image) {
      this.uploadedImageFile = image.dest;
      this.uploadedImage = URL.createObjectURL(image.dest);
      this.takeScreenShot = false;
      this.takeImage = true;
      this.imageTakeView = false;
    },
  },
  mounted() {
    setTimeout(() => {
      this.$helpers.updateColorAccordingApi();
    }, 100);
    window.addEventListener("resize", () => {
      if (this.$helpers.isWebDevice()) {
        this.isWebDevice = true;
      } else {
        this.isWebDevice = false;
      }
    });
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          // console.log(event.data.option);
          if (event.data.settings) {
            for (let key in event.data.settings) {
              this.response.settings[key] = event.data.settings[key];
            }
            this.$session.set("response", this.response);
            var this_pointer = this;
            setTimeout(function() {
              this_pointer.$helpers.resizeIframeEvent();
            }, 300);
          } else if (event.data.option) {
            this.response = this.$session.get("response");
            this.setting = this.$session.get("response").settings;
            // console.log(this.response);
          }
        }
      },
      false
    );
    this.$helpers.resizeIframeEvent();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fa-spinner {
  margin-right: 8px;
}
.btn-solid {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: var(--action-btn-color) !important;
  background: var(--accent-color);
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  padding: 0 25px;
  .icon {
    margin-right: 8px;
    fill: var(--action-btn-color);
  }
  &:hover {
    color: var(--action-btn-color);
  }
}
.btn-hollow {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.01em;
  color: var(--accent-color);
  border-color: var(--accent-color);
  height: 35px;
  padding: 0 25px;
  svg {
    margin-right: 8px;
    fill: var(--accent-color);
  }
  &:hover {
    color: var(--accent-color) !important;
  }
}
textarea.form-control {
  width: 100%;
  resize: none;
  height: 115px;
  border: 1px solid #ebedf0;
  border-radius: 4px;
  padding: 11px 8px;
  font-family: "Mulish", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: #56657f;

  &::placeholder {
    color: #afbdd1;
  }
}
.feedback-header {
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  p {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: var(--title-color);
    margin: 0;
    margin-left: 8px;
  }
}

.feedback-option {
  .panel {
    background: #ffffff;
    border-radius: 4px;
    padding: 18px 10px;

    .question-detail {
      .uploaded-image {
        max-height: 275px;
        display: flex;
        align-items: center;
        img {
          max-height: 275px;
          border-radius: 5px;
        }
      }
      .question-number {
        margin-bottom: 8px;
        .icon {
          margin-right: 8px;
        }
        .title {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 15px;
          line-height: 24px;
          letter-spacing: 0.01em;
          color: #56657f;
        }
      }

      .question-title {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.01em;
        color: #313c4e;
        text-align: left;
        margin-bottom: 16px;
      }

      .question-subtitle {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.01em;
        color: #56657f;
        text-align: left;
        margin-bottom: 32px;
      }

      .question-options {
        .option-head {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: var(--accent-color);
          text-align: left;
        }

        .options {
          .image-option {
            padding: 0 17px;
          }
          .option-item {
            background: var(--accent-color);
            border-radius: 5px;
            width: 100%;
            height: 71px;
            margin-right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: relative;
            cursor: pointer;

            input {
              position: absolute;
              top: 0;
              bottom: 0;
              right: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
              cursor: pointer;
            }

            &:last-child {
              margin-right: 0px;
            }

            svg {
              margin-bottom: 6px;
            }
            .upload-style {
              font-family: "Poppins", sans-serif;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 18px;
              text-align: center;
              letter-spacing: 0.01em;
              color: #ffffff;
            }

            p {
              font-family: "Poppins", sans-serif;
              font-style: normal;
              font-weight: 500;
              font-size: 12px;
              line-height: 18px;
              text-align: center;
              letter-spacing: 0.01em;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
}

.recording-time {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin-top: 16px;

  img {
    margin-right: 10px;
  }

  .title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.01em;
    color: #313c4e;
    margin-bottom: 0px;
  }

  .time {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: var(--accent-color);
    margin-bottom: 0px;
    margin-left: 10px;
  }
}

.recording-time-warning {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin-top: 16px;

  img {
    margin-right: 10px;
  }

  .title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0.01em;
    color: #ff3d00;
    margin-bottom: 0px;
    display: flex;
    align-items: center;

    span {
      font-size: 13px;
      line-height: 20px;
      margin-left: 10px;
    }
  }
}

.back-btn {
  margin-bottom: 35px;
  .icon {
    margin-right: 8px;
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
    }
  }
}
.copyright {
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
  padding: 5px 11px;
  background: #fff;
  margin-bottom: 15px;
  border-radius: 40px;
  .icon {
    margin-right: 4.84px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 3px;
  }
  .text {
    p {
      font-family: "Mulish", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 15px;
      color: #8997b1;
    }
  }
}
a {
  text-decoration: none;
}

.uploaded-image {
  // height: 275px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  border-radius: 5px;

  img {
    border-radius: 5px;
  }
}

.videojs {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-inner-container {
  max-height: 278px;
  height: auto;
  width: auto;
  border-radius: 5px;
  min-height: 278px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .videoPlayer-dimensions.vjs-fluid {
    padding-top: 0;
  }
}
.video-js.vjs-fluid,
.video-js.vjs-16-9,
.video-js.vjs-4-3 {
  width: auto;
  max-width: 100%;
  height: 278px !important;
  border-radius: 5px;
  overflow: hidden;

  .vjs-tech {
    position: initial;
    // width: auto;  // Cut the video from corner sides
    height: 100%;
  }

  .vjs-control-bar {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3em;
    background-color: rgba(43, 51, 63, 0.7);
  }
}
</style>
